// ============================================================
// dtbase v2：preset_prefab 元数据 Schema（规范 §5）
// ============================================================
import { z } from 'zod';

const vec3Schema = z.array(z.number()).length(3);

export const prefabMetaSchema = z
  .object({
    prefabId: z.string().min(1).max(128),
    name: z.string().min(1).max(200),
    semanticTags: z.array(z.string().max(40)).max(20).default([]),
    defaultBindPoints: z.array(z.string().max(64)).max(50).default([]),
    lodList: z.array(z.string().min(1).max(200)).min(1).max(5),
    bbox: z.object({ min: vec3Schema, max: vec3Schema }).strict().optional(),
    triBudget: z.number().int().positive().optional(),
    materials: z.array(z.string().max(128)).max(100).default([]),
    source: z
      .object({
        type: z.string().max(32),
        from: z.string().max(64).optional(),
        pipeline: z.string().max(64).optional(),
      })
      .strict()
      .optional(),
    aiGenerated: z.boolean().default(false),
  })
  .strict();

export type PrefabMeta = z.infer<typeof prefabMetaSchema>;
